import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRancherComponent } from './simple-icons-rancher.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRancherComponent ],
    exports:      [ SimpleIconsRancherComponent ],
    bootstrap:    []
})
export class SimpleIconsRancherModule {}
